import React, {useContext, useEffect} from "react"
import PropTypes from "prop-types";
import BoldTypography from "components/BoldTypography";
import GridBlock from "components/GridBlock";
import BasicSearch from "components/BasicSearch";
import Tr from "translations/Translations";
import Button from "components/Button";
import AddIcon from "@material-ui/icons/AddBoxOutlined";
import {getAnnualReportEditPopup} from "./AnnualReportEditPopup";
import FormTranslationContext from "context/FormTranslationContext";
import HelpTooltip from "components/HelpTooltip";
import useSearch from "../../../../../../hooks/useSearch";

function AnnualReportSearchBar(
    {
        classes,
        setSearch,
        reportStep,
        disabled,
        setEditPopup
    }
) {
    const {searchData, setSearchConfig} = useSearch();
    useEffect(()=> {
        setSearch(searchData.search)
    },[searchData, setSearch])

    const {formTip, formTr} = useContext(FormTranslationContext);
    const tip = formTip("mmia." + reportStep);
    return (<>
            <BoldTypography variant="h5">{formTr("mmia." + reportStep)} {!!tip && <HelpTooltip text={formTip("mmia." + reportStep)}/>}</BoldTypography>

            <GridBlock justify="space-between" className={classes.marginBottom}>
                <BasicSearch
                    label={Tr('search_by_demand_number')}
                    doSearch={setSearchConfig}
                />
                <Button disabled={disabled} Icon={AddIcon} onClick={() => setEditPopup(getAnnualReportEditPopup(null, true))}>{Tr("add_demand")}</Button>
            </GridBlock>
        </>
    )
}

AnnualReportSearchBar.propTypes = {
    classes: PropTypes.object.isRequired,
    setSearch: PropTypes.func.isRequired,
    reportStep: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    setEditPopup: PropTypes.func.isRequired
}
export default AnnualReportSearchBar;